import React from 'react';
import { ModalForm } from '@/components/ModalForm';
import { Button } from '@ui/button';
import { cn } from 'src/utilities/cn';
import { getCachedGlobal } from '@/utilities/getGlobals';

import type { ModalFormButtonBlock } from '@/payload-types';

type Props = ModalFormButtonBlock & {
  className?: string;
};

export const ModalFormButton: React.FC<Props> = async ({
  textInButton,
  isTextLike,
  className,
}) => {
  return (
    <ModalForm
      toggleStyle={cn('mt-8 md:mt-5', className, isTextLike && 'inline')}
      toggle={
        isTextLike ? (
          <a className="text-primary no-underline">{textInButton}</a>
        ) : (
          <Button>{textInButton}</Button>
        )
      }
    />
  );
};
